const typography = palette => ({
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "29px",
    lineHeight: "32px"
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "28px"
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px"
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "20px"
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px"
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "18px"
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "18px"
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: "12px",
    letterSpacing: "-0.04px",
    lineHeight: "18px"
  },
  body1: {
    color: palette.text.primary,
    fontSize: "12px",
    letterSpacing: "-0.04px",
    lineHeight: "18px"
  },
  body2: {
    color: palette.text.secondary,
    fontSize: "10px",
    letterSpacing: "-0.03px",
    lineHeight: "12px"
  },
  button: {
    color: palette.text.primary,
    fontSize: "12px"
  },
  caption: {
    color: palette.text.secondary,
    fontSize: "9px",
    letterSpacing: "0.33px",
    lineHeight: "11px"
  },
  overline: {
    color: palette.text.secondary,
    fontSize: "9px",
    fontWeight: 500,
    letterSpacing: "0.335px",
    lineHeight: "11px",
    textTransform: "uppercase"
  }
})

export default typography
